
<svelte:head>
  <title>{data?.title || "Need"} | A Good Thing</title>
</svelte:head>

{#if !data}

  {#if notFound}
  <article class="message is-success">
    <div class="message-body">
      <p class="block">
        <b>This charity need is no longer active.</b>
      </p>
      <p class="block">
        View current charity needs <a href="{$appState.origin}/signup">here</a> .
      </p>
    </div>
  </article>
  {/if}

{:else}

<article class="message is-success">
  <div class="message-body">
    <p class="block">
      <b>Are you a business that could help this charity?</b>
    </p>
    <p class="block">
      A Good Thing is a digital platform that makes it easy for businesses to donate unwanted items to local charities. <a href="{$appState.origin}/signup">Sign up</a> to get started.
    </p>
    <p class="block">
      Already signed up? <a href="{$appState.origin}/business/need/{needid}">Log in</a> to respond to this need.
    </p>
  </div>
</article>
<div class="columns">
  <div class="column is-narrow">
    {#if data.images?.[0]}
      <img
        alt="Offer"
        on:click={() => {
          $uiState.activeModal = {
            component: Lightbox,
            props: { images: data.images, index: 0 },
          };
        }}
        src={data.images[0]}
        style="width:240px; cursor:pointer;"
      />
    {:else}
      <img
        alt="Generic"
        src="/assets/img/box.png"
        style="height:240px;width:240px; background-color:lightgrey"
      />
    {/if}
    <div style="width:250px;">
      {#if data.images && data.images.length > 1}
        {#each data.images as url, index}
          {#if index !== 0}
            <div style="display:inline-block;margin-right: 8px;">
              <img
                alt="Need"
                on:click={() => {
                  $uiState.activeModal = {
                    component: Lightbox,
                    props: { images: data.images, index },
                  };
                }}
                src={url}
                style="max-width:116px;"
              />
            </div>
          {/if}
        {/each}
      {/if}
    </div>
  </div>

  <div class="column">

    <h2 class="block title">{data.title}</h2>
    <h2 class="block subtitle">Needed by {data.charityDetails.name}</h2>

    {#if createdDatePhrase}
      <p class="block has-text-grey-light">Published {createdDatePhrase}</p>
    {/if}

    <div class="block">
      <!-- Left side -->
      <div class="level-left">
        <a class="button is-primary" href="{$appState.origin}/signup">Respond to this need</a>
      </div>
    </div>

    <p class="block"><strong>What they need</strong></p>
    <p class="block" style="white-space:pre-wrap;">{data.needs}</p>

    <hr />

    <p class="block"><strong>Why they need it</strong></p>
    <p class="block" style="white-space:pre-wrap;">{data.benefits}</p>

    <hr />

    {#if data.background}
    <p class="block"><strong>About the charity</strong></p>
    <p class="block" style="white-space:pre-wrap;">{data.background}</p>

    <hr />
    {/if}


    {#if charity}
      {#if charity.type === 'EnglandAndWalesRegistered'}
        <EnglandWalesCharityFull charity={charity} />
      {:else if charity.type === 'ScotlandRegistered'}
        <ScotlandCharityFull {charity} />
      {:else if charity.type === 'NorthernIrelandRegistered'}
        <NorthernIrelandCharityFull {charity} />
      {:else if charity.type === 'CIC'}
        <CICFull {charity} />
      {:else if charity.type === 'CBS'}
        <CBSFull {charity} />
      {:else if charity.type === 'HMRCCharity'}
        <HMRCCharityFull {charity} />
      {:else}
        <UnregisteredCharityFull {charity} />
      {/if}
    {/if}

  </div>
</div>
{/if}

<script lang="ts">
  export let needid : string;

  import _ from "lodash";
  import { appState } from "../../../../lib/appState";
  import { uiState } from "../../../../lib/uiState";
  import dayjs from "dayjs";
  import relativeTime from "dayjs/plugin/relativeTime";
  import Lightbox from "../../../_components/Lightbox.svelte";

  import EnglandWalesCharityFull from "../../../_components/org_profiles/EnglandWalesCharityFull.svelte";
  import ScotlandCharityFull from "../../../_components/org_profiles/ScotlandCharityFull.svelte";
  import NorthernIrelandCharityFull from '../../../_components/org_profiles/NorthernIrelandCharityFull.svelte';
  import CICFull from '../../../_components/org_profiles/CICFull.svelte';
  import CBSFull from '../../../_components/org_profiles/CBSFull.svelte';
  import HMRCCharityFull from '../../../_components/org_profiles/HMRCCharityFull.svelte';
  import UnregisteredCharityFull from "../../../_components/org_profiles/UnregisteredCharityFull.svelte";

  dayjs.extend(relativeTime);

  let notFound = false;

  let data : Need_v1;

  let charity : Charity_v2;

  let firebase = window.firebase;

  $: createdDatePhrase = data?.created ? dayjs().to(dayjs(data.created)) : undefined;

  get();

  async function get() {

    const doc = await firebase
      .firestore()
      .collection("needs_v1")
      .doc(needid)
      .get();

    if(doc.exists) {
      data = doc.data() as Need_v1;
      getCharity(data.charity);
    }
    
    notFound = true;
  }

  async function getCharity(charityId : CharityId) {
    firebase
      .firestore()
      .collection("charities_v2")
      .doc(charityId)
      .onSnapshot(async (doc) => {
        if(doc.exists) {
          charity = doc.data() as Charity_v2;
        }
      });
  }
</script>
